let setPopup = null;

// Accumulates data-props up the ancestor chain while taking the nearest
// data-path, so right-clicking one wedge of a role's spinner produces a menu
// scoped to that log level. Read through getAttribute rather than the attributes
// map so this works over both a DOM element and a scene node.
export function getNodeProps(elem) {
  let props = {};
  let path = null;
  while (elem != null) {
    if (path == null) {
      const nodePath = elem.getAttribute("data-path");
      if (nodePath != null) path = nodePath;
    }
    const extraProps = elem.getAttribute("data-props");
    if (extraProps) {
      props = { ...props, ...JSON.parse(extraProps) };
    }
    elem = elem.parentElement;
  }
  return { path, props };
}

export function initialise(set) {
  setPopup = set;
}

export function openItemMenu(elem, x, y) {
  const { path, props } = getNodeProps(elem);
  if (!path) return;
  setPopup({
    x,
    y,
    path: path,
    extraProps: props,
    visible: true,
  });
}
